<template>
  <div>
    <v-layout row justify-space-between>
      <v-flex>
        <v-flex text-xs-center class="py-4" v-if="warnings.length > 0">
          <v-icon color="error" small class="pr-2">info</v-icon>
          <b
            >{{ warnings.length }}
            {{ pluralize("document", warnings.length) }} have not been yet
            uploaded or generated:</b
          >
          <br />
          <div v-for="(w, i) in warnings" :key="i">
            <b>{{ w.step_template.name.toUpperCase() }}</b>
          </div>
        </v-flex>
        <v-text-field
          label="Recipient"
          v-model="email.interpolated_recipient"
          background-color="white"
          required
        />
        <v-layout row justify-space-between>
          <v-flex>
            <v-text-field
              label="CC"
              v-model="email.interpolated_cc"
              background-color="white"
            />
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex>
            <v-text-field
              label="BCC"
              v-model="email.interpolated_bcc"
              background-color="white"
            />
          </v-flex>
        </v-layout>

        <v-text-field
          class="font-weight-bold"
          label="Subject"
          v-model="email.interpolated_subject"
          background-color="white"
        />

        <div class="px-0 pt-4">
          <div class="document-editor">
            <div
              :id="'ck-toolbar-' + step.id"
              class="document-editor__toolbar"
            ></div>
            <div class="noBottomBorder">
              <ckeditor
                @ready="onReady"
                :editor="editor"
                v-model="email.interpolated_body"
                :config="editorConfig"
              />
            </div>
          </div>
          <div class="ckborder">
            <v-flex xs12 pa-2>
              <v-expansion-panel
                v-model="showedAttachments"
                light
                class="elevation-0"
              >
                <v-expansion-panel-content>
                  <v-flex xs6 offset-xs3 pb-4 py-2>
                    <v-divider></v-divider>
                  </v-flex>
                  <h4 class="pl-2 pb-2">
                    <v-icon class="pr-1" small>assignment</v-icon>Contract
                    documents :
                  </h4>
                  <v-layout row wrap pa0>
                    <template v-for="(file, index) in availableAttachments">
                      <v-flex xs12 sm12 md6 xl3 lg3 pa-2 :key="'doc_' + index">
                        <v-list two-line subheader>
                          <v-list-tile
                            color="black"
                            class="fileList"
                            ripple
                            avatar
                            @click="
                              isDocumentAttached(file)
                                ? removeAttachmentByUrl(file.url)
                                : attachStepDocument(file)
                            "
                          >
                            <v-list-tile-avatar>
                              <v-icon
                                color="white"
                                v-if="!isDocumentAttached(file)"
                                :class="
                                  fileIconColor(file.url) +
                                  ' lighten-1 white--text'
                                "
                                >{{ fileIcon(file.url) }}</v-icon
                              >
                              <v-icon
                                v-if="isDocumentAttached(file)"
                                color="white"
                                class="success lighten-1 white--text'"
                                >check</v-icon
                              >
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                              <v-list-tile-title class="body-1">{{
                                file.name
                              }}</v-list-tile-title>
                              <v-list-tile-sub-title>
                                <a
                                  class="caption"
                                  :href="`${s3bucket}/${file.url}`"
                                  target="_blank"
                                  >{{ file.url }}</a
                                >
                              </v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-list>
                      </v-flex>
                    </template>

                    <v-flex xs12 sm12 md6 xl3 lg3 pa-2>
                      <v-list two-line subheader>
                        <v-list-tile
                          color="black"
                          class="uploadList"
                          ripple
                          avatar
                        >
                          <v-list-tile-avatar>
                            <v-icon color="#121212" class="grey white--text"
                              >cloud_upload</v-icon
                            >
                          </v-list-tile-avatar>
                          <v-list-tile-content style="display: block;">
                            <uploader
                              v-on:s3url="attachUploadedDocument"
                              allowMultiple
                            />
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                    </v-flex>
                  </v-layout>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-flex>

            <v-layout column v-if="attachments.length > 0">
              <v-flex pb-2>
                <v-tooltip right v-if="attachments.find((a) => a.must_merge)">
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip v-bind="attrs" v-on="on">
                      <h4>All Docs.pdf</h4>
                    </v-chip>
                  </template>
                  <span v-for="(file, index) in orderedMergedAttachments()">
                    {{ file.name }} <br />
                  </span>
                </v-tooltip>

                <v-chip
                  close
                  v-for="(file, index) in attachments.filter(
                    (a) => !a.must_merge
                  )"
                  :key="index"
                  @input="removeAttachment(index)"
                >
                  <h4>{{ file.name }}</h4>
                </v-chip>
              </v-flex>
            </v-layout>

            <v-footer height="auto">
              <v-layout row wrap pa0>
                <v-flex xs12 pa0 px-1>
                  <v-btn
                    icon
                    small
                    :color="showedAttachments != -1 ? 'primary' : 'transparent'"
                    depressed
                    @click="setShowAttachement(0)"
                  >
                    <v-badge
                      bottom
                      :value="availableAttachments.length && showedAttachments"
                    >
                      <span slot="badge">{{
                        availableAttachments.length
                      }}</span>
                      <v-icon size="20">attach_file</v-icon>
                    </v-badge>
                  </v-btn>

                  <v-btn
                    style="float: right;"
                    color="primary"
                    small
                    depressed
                    @click.prevent="displayPreview()"
                  >
                    <v-icon small class="pr-2">mdi-email-send</v-icon>Send
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-footer>
          </div>
        </div>
      </v-flex>
    </v-layout>
    <v-dialog v-model="show_preview" scrollable max-width="1024">
      <v-card>
        <v-toolbar
          tile
          card
          flat
          dense
          color="theme_primary"
          class="white--text"
          height="36"
        >
          <v-spacer></v-spacer>
          <v-toolbar-title class="white-text text-capitalize"
            >Mail Preview</v-toolbar-title
          >

          <v-spacer></v-spacer>
          <v-toolbar-side-icon>
            <v-icon color="white">mail</v-icon>
          </v-toolbar-side-icon>
        </v-toolbar>
        <v-card-text class="pa-0">
          <div
            v-if="show_preview && !actionDone"
            v-html="
              mailBeautifier(
                email.interpolated_body,
                email.interpolated_subject,
                CtCMailTemplate
              )
            "
          ></div>
          <v-layout
            style="height: 300px;"
            column
            align-center
            class="text-xs-center"
            v-if="actionDone"
          >
            <v-spacer></v-spacer>
            <v-flex class="text-xs-center">
              <v-icon color="success" size="80">mdi-email-check</v-icon>

              <h3 style="color: #555;" class="pt-4">Email sent!</h3>
            </v-flex>
          </v-layout>

          <v-layout
            style="height: 300px;"
            column
            align-center
            class="text-xs-center"
            v-if="errorWhenSendingMail"
          >
            <v-spacer></v-spacer>
            <v-flex class="text-xs-center">
              <v-icon color="error" size="80">mdi-email-alert</v-icon>

              <h3 style="color: #555;" class="pt-4">Error Sending Mail</h3>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn
            small
            color="red darken-1"
            flat="flat"
            @click="show_preview = false"
          >
            <v-icon small class="pr-2">close</v-icon>Close
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            depressed
            small
            @click.prevent="sendEmail"
            :disabled="
              warnings.length > 0 ||
              actionDone ||
              !email.interpolated_recipient ||
              isSending
            "
          >
            <v-icon small class="pr-2">{{
              actionDone ? "mdi-email-check" : "mdi-email-send"
            }}</v-icon>
            {{ actionDone ? "Sent" : "Send" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import SEND_EMAIL from "../../graphql/steps/send_email.gql";
import uploader from "./uploader";
import { mapGetters } from "vuex";
import files from "../../mixins/files.js";
import date from "../../mixins/date.js";

//CKEditor Imports:
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import CKEditor from "@ckeditor/ckeditor5-vue";

import EssentialsPlugin from "@ckeditor/ckeditor5-essentials/src/essentials";
//import AutoformatPlugin from "@ckeditor/ckeditor5-autoformat/src/autoformat";
import BlockQuotePlugin from "@ckeditor/ckeditor5-block-quote/src/blockquote";
import BoldPlugin from "@ckeditor/ckeditor5-basic-styles/src/bold";
import ItalicPlugin from "@ckeditor/ckeditor5-basic-styles/src/italic";
import LinkPlugin from "@ckeditor/ckeditor5-link/src/link";
import ListPlugin from "@ckeditor/ckeditor5-list/src/list";
import ParagraphPlugin from "@ckeditor/ckeditor5-paragraph/src/paragraph";
import AlignmentPlugin from "@ckeditor/ckeditor5-alignment/src/alignment";
import Table from "@ckeditor/ckeditor5-table/src/table";
import TableToolbar from "@ckeditor/ckeditor5-table/src/tabletoolbar";
import PasteFromOffice from "@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice";
import MediaEmbed from "@ckeditor/ckeditor5-media-embed/src/mediaembed";
import Font from "@ckeditor/ckeditor5-font/src/font";
import Image from "@ckeditor/ckeditor5-image/src/image";
import ImageToolbar from "@ckeditor/ckeditor5-image/src/imagetoolbar";
import ImageCaption from "@ckeditor/ckeditor5-image/src/imagecaption";
import ImageStyle from "@ckeditor/ckeditor5-image/src/imagestyle";
import ImageUploader from "@ckeditor/ckeditor5-image/src/imageupload";
import Underline from "@ckeditor/ckeditor5-basic-styles/src/underline";
import Strikethrough from "@ckeditor/ckeditor5-basic-styles/src/strikethrough";
import CtCMailTemplate from "raw-loader!../../../public/mail_templates/ctc_template/ctc_template.html";
import CtCTrackingMailTemplate from "raw-loader!../../../public/mail_templates/ctc_template/ctc_tracking_template.html";
import CtCTrackingMailTemplateBloc from "raw-loader!../../../public/mail_templates/ctc_template/ctc_tracking_template_bloc.html";
import ckEditorCustom from "../../plugins/ckEditorCustom";
import pluralize from "pluralize";

export default {
  name: "emailSender",
  components: {
    uploader,
    ckeditor: CKEditor.component,
  },
  mixins: [files, date],
  props: {
    email: {
      type: Object,
      required: true,
    },
    stepTemplateId: {
      type: String,
      required: true,
    },
    step: {
      type: Object,
      required: true,
    },
    expeditionId: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      pluralize,
      show_preview: false,
      CtCMailTemplate,
      CtCTrackingMailTemplate,
      CtCTrackingMailTemplateBloc,
      showUploader: false,
      showAvailebleDocs: false,
      editor: ClassicEditor,
      warnings: [],
      isSending: false,
      editorConfig: {
        plugins: [
          EssentialsPlugin,
          //AutoformatPlugin,
          BoldPlugin,
          ItalicPlugin,
          LinkPlugin,
          ListPlugin,
          ParagraphPlugin,
          BlockQuotePlugin,
          AlignmentPlugin,
          Table,
          TableToolbar,
          PasteFromOffice,
          MediaEmbed,
          Font,
          Image,
          ImageToolbar,
          ImageCaption,
          ImageStyle,
          ImageUploader,
          Underline,
          Strikethrough,
          ckEditorCustom,
        ],
        fontSize: {
          options: [
            "tiny",
            "small",
            "default",
            "big",
            "huge",
            6,
            9,
            11,
            13,
            15,
            19,
            21,
            23,
            25,
            27,
            29,
            34,
          ],
        },
        table: {
          contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
        },
        image: {
          toolbar: [
            "imageStyle:alignLeft",
            "imageStyle:full",
            "imageStyle:alignRight",
          ],
          styles: ["full", "alignLeft", "alignRight"],
        },
        toolbar: {
          items: [
            "undo",
            "redo",
            "|",
            "fontSize",
            "fontFamily",
            "fontColor",
            "fontBackgroundColor",
            "|",
            "bold",
            "italic",
            "underline",
            "strikethrough",
            "alignment",
            "|",
            "bulletedList",
            "numberedList",
            "blockQuote",
            "|",
            "link",
            "MediaEmbed",
            //"imageUpload",

            "|",
            "insertTable",
          ],
        },
      },
      s3bucket: process.env.VUE_APP_S3_BUCKET_URL,
      show: false,
      actionDone: false,
      showedAttachments: -1,
      attachments: [],
      pdf: {},
      errorWhenSendingMail: false,
    };
  },
  computed: {
    ...mapGetters("contractStore", [
      "expeditionDocuments",
      "contractDocuments",
      "contract",
    ]),
    ...mapGetters("commonStore", ["text_interpolations"]),
    availableAttachments() {
      this.attachDefaultDocuments();

      return this.expeditionId
        ? this.expeditionDocuments
        : this.contractDocuments;
    },
  },
  methods: {
    attachDefaultDocuments() {
      let availableAttachments = [];
      this.warnings = [];
      let customerParameterIds = [];

      let contractExpeditions = this.contract.expeditions.find(
        (e) => e.id == this.expeditionId
      )

      let steps = (contractExpeditions && contractExpeditions.steps) || this.contract.steps;
      let originalOfDraftIds = steps
        .filter((s) => s.step_template.draft_of_step_template_id)
        .map((s) => s.step_template.draft_of_step_template_id);

      availableAttachments = this.expeditionId
        ? this.expeditionDocuments
        : this.contractDocuments;
      if (this.expeditionId)
        customerParameterIds = this.email.step.expedition.contract
          .customer_parameter_ids;
      else
        customerParameterIds = this.email.step.contract.customer_parameter_ids;

      console.log("availableAttachments", availableAttachments)
      console.log("email_template", this.email)

      this.email.email_template.email_attachment_templates
        .filter((emAttTemp) => {
          return (
            !emAttTemp.customer_parameter_id ||
            customerParameterIds.includes(emAttTemp.customer_parameter_id)
          );
        })
        .forEach((emAttTemp) => {
          if (
            !availableAttachments
              .map((att) => att.step_template_id)
              .includes(emAttTemp.step_template_id) &&
            steps
              .map((s) => s.step_template.id)
              .includes(emAttTemp.step_template_id) &&
            !originalOfDraftIds.includes(emAttTemp.step_template_id)
          ) {
            this.warnings.push(emAttTemp);
          }

          availableAttachments.forEach((att) => {
            if (
              emAttTemp.step_template &&
              emAttTemp.step_template.draft_of_step_template_id
            ) {
              let original = steps.find(
                (s) =>
                  s.step_template.id ==
                  emAttTemp.step_template.draft_of_step_template_id
              );

              if (
                original &&
                availableAttachments
                  .map((att) => att.step_template_id)
                  .includes(original.step_template.id)
              ) {
                return;
              }
            }
            if (emAttTemp.step_template_id == att.step_template_id)
              this.attachStepDocument(att, emAttTemp);
          });
        });
    },
    onReady(editor) {
      const toolbarContainer = document.querySelector(
        "#ck-toolbar-" + this.step.id
      );
      toolbarContainer.appendChild(editor.ui.view.toolbar.element);
    },
    sendEmail() {
      this.isSending = true;
      this.errorWhenSendingMail = false;
      this.email.attachment_attributes = [];
      for (var i = 0; i < this.attachments.length; i++) {
        this.email.attachment_attributes.push({
          url: this.attachments[i].url,
          origin: this.attachments[i].origin,
          must_merge: this.attachments[i].must_merge,
          order_index: this.attachments[i].order_index,
        });
      }
      this.email.subject = this.email.interpolated_subject;
      this.email.cc = this.email.interpolated_cc;
      this.email.bcc = this.email.interpolated_bcc;
      this.email.recipient = this.email.interpolated_recipient;
      this.email.body = this.mailBeautifier(
        this.email.interpolated_body,
        this.email.subject,
        this.CtCMailTemplate
      );
      this.sendMutation("sent", "email", SEND_EMAIL, this.email)
        .then(() => {
          this.actionDone = true;
          this.$emit("emailSended", true);
          this.isSending = false;
        })
        .catch(() => {
          this.isSending = false;
          this.errorWhenSendingMail = true;
        });
    },
    orderedMergedAttachments() {
      return this.attachments
        .filter((a) => a.must_merge)
        .sort((a, b) => (a.order_index < b.order_index ? -1 : 1));
    },
    trackingBlocFromExpeditionId(expeditionId) {
      var tracking_html = "";
      tracking_html = this.CtCTrackingMailTemplate;

      let expedition = this.contract.expeditions.find((exp) => {
        return exp.id == expeditionId;
      });

      let _bl_number = expedition.bl_number ? expedition.bl_number : "";
      let _booking_number = expedition.booking_number
        ? expedition.booking_number
        : "";
      let _vessel_name = expedition.vessel_name ? expedition.vessel_name : "";
      let _eta = expedition.eta ? this.timeToDate(expedition.eta) : "";
      let _etd = expedition.etd ? this.timeToDate(expedition.etd) : "";
      let _shipping_company_name = expedition.shipping_company
        ? expedition.shipping_company.name.toUpperCase()
        : "";
      let _loading_port = this.contract.loading_port
        ? this.contract.loading_port.name.toUpperCase()
        : "";
      let _unloading_port = this.contract.unloading_port
        ? this.contract.unloading_port.name.toUpperCase()
        : "";

      //Urls
      let _bl_url = "";
      let _booking_url = "";
      let _containers_url_base = "";

      if (expedition.shipping_company && expedition.shipping_company.supplier) {
        if (
          _bl_number &&
          expedition.shipping_company.supplier.shipping_tracking_url_bl
        )
          _bl_url = expedition.shipping_company.supplier.shipping_tracking_url_bl.replace(
            "{{reference}}",
            _bl_number
          );

        if (
          _booking_number &&
          expedition.shipping_company.supplier.shipping_tracking_url_booking
        )
          _booking_url = expedition.shipping_company.supplier.shipping_tracking_url_booking.replace(
            "{{reference}}",
            _booking_number
          );

        if (
          expedition.shipping_company.supplier
            .shipping_tracking_url_shipment_unit
        ) {
          _containers_url_base =
            expedition.shipping_company.supplier
              .shipping_tracking_url_shipment_unit;
        }
      }

      let _containers_html = "";

      let _is_url = _containers_url_base && _containers_url_base.length > 0;
      let _style =
        ' style="text-decoration:' +
        (_is_url ? "underline" : "none") +
        '; color:#1976d2; margin-right: 8px;white-space: nowrap;"';
      expedition.shipping_units.forEach((su) => {
        _containers_html +=
          "<" +
          (_is_url
            ? "a target = '_blank' href='" +
              _containers_url_base.replace(
                "{{reference}}",
                su.reference_value
              ) +
              "' "
            : "span ") +
          _style +
          ">";
        _containers_html += su.reference_value ? su.reference_value : "N/A";
        _containers_html += "</" + (_is_url ? "a" : "span") + ">";
      });

      tracking_html = tracking_html
        .replace("{{bl_number}}", _bl_number)
        .replace("{{bl_url}}", _bl_url)
        .replace("{{booking_number}}", _booking_number)
        .replace("{{booking_url}}", _booking_url)
        .replace("{{vessel_name}}", _vessel_name)
        .replace("{{loading_port}}", _loading_port)
        .replace("{{unloading_port}}", _unloading_port)
        .replace("{{shipping_company}}", _shipping_company_name)
        .replace("{{etd}}", _etd)
        .replace("{{eta}}", _eta)
        .replace("{{container_urls}}", _containers_html);

      if (_vessel_name == "")
        tracking_html = tracking_html.replace("Vessel Name", "");

      return tracking_html;
    },
    trackingBlocGenerate() {
      var ret_html = "";

      if (this.expeditionId) {
        ret_html = this.trackingBlocFromExpeditionId(this.expeditionId);
      } else {
        let _separator_html = `<table cellpadding="0" cellspacing="0" summary="" width="100%"  bgcolor="ffffff"
          style="border:0 none;border-collapse:collapse; margin-top:30px">
          <tbody><tr>
                <td width="30" valign="middle" style="vertical-align:top;line-height:1px;width:30px"></td>
                <td height="1" style="vertical-align:top;line-height:1px">
                  <p style="margin:0;border-bottom-width:1px;border-bottom-color:#cecece;border-bottom-style:solid;font-size:1px;line-height:1px">&nbsp;</p>
                </td>
                <td width="30" valign="middle" style="vertical-align:top;line-height:1px;width:30px"></td>
              </tr></tbody></table>`;

        let i = 0;
        this.contract.expeditions.forEach((exp) => {
          ret_html += this.trackingBlocFromExpeditionId(exp.id);
          if (i < this.contract.expeditions.length - 1)
            ret_html += _separator_html;
          i++;
        });
      }
      return ret_html;
    },
    trackingBlocRow(label, value, url) {
      return this.CtCTrackingMailTemplateBloc.replace("{{label}}", label)
        .replace("{{value}}", value)
        .replace("{{url}}", url);
    },
    mailBeautifier(mail_body, mail_subject, mail_template) {
      var exportStr =
        "<html><head> <base href='" + process.env.VUE_APP_URL + "' >";

      exportStr +=
        '</head><body><div class="document-editor__editable"><div class="ck ck-reset ck-editor ck-rounded-corners ck-content ck-editor__editable ck-rounded-corners ck-editor__editable_inline ck-blurred ckeditor_main_container">';

      exportStr += mail_template
        .replace(
          "{{ mail_content }}",
          mail_body.replace("{{TRACKING}}", this.trackingBlocGenerate())
        )
        .replace("{{ mail_subject }}", mail_subject);
      exportStr += "</div></div></div></body></html>";

      // CSS INLINER
      var juice = require("juice");

      // MINIMUM CSS REQUIERED TO GET TABLES DISPLAYED PROPERLY
      var additional_css =
        "<style>.table {border-collapse: collapse !important; margin:0px !important;} .ck-content .table {{ margin:0px !important; border-collapse: collapse !important; margin-bottom: 2em !important;margin-top: 2em !important;}.ck-content .table table {{border-collapse: collapse !important; width: 100% !important;border: 1px #bababa solid !important;table-layout: fixed !important;}.ck-content .table table th {background: none !important;color: #747474 !important;}.ck-content .table table td {color: #414141 !important;}.ck-content .table table thead {border-bottom: 1px #bababa solid !important;}.ck-content .table table tbody tr {height: auto !important;}.ck-content .table table tbody tr:first-child {border-top: none !important;}.ck-content .table table th, .ck-content .table table td {min-width: 1em !important;padding: 0.4em !important;padding-top: 0.25em !important;padding-left: 0.6em !important;padding-bottom: 0.25em !important;box-shadow: none !important;font-family: Arial, serif !important;font-size: 10px !important;font-weight: normal !important;font-style: normal !important;text-decoration: none !important;border: none !important;text-align: left !important;}table.v-table thead th {font-weight: 600 !important;}.document-editor .ck-content p {margin-bottom: 0px !important;}.ck-content .table table td p {min-width: 1em !important;padding: 0.4em !important;padding-top: 0.2em !important;padding-bottom: 0.2em !important;box-shadow: none !important;font-family: Arial, serif !important;font-size: 10px !important;font-weight: normal !important;font-style: normal !important;text-decoration: none !important;border: none !important;margin: 0 !important;} #product_loop_table table{{border-collapse: collapse !important; border: none !important;}#product_loop_table table thead {border: 1px #bababa solid !important;}#product_loop_table table tr {border-left: 1px #bababa solid !important;border-right: 1px #bababa solid !important;border-top: 1px #eee solid !important;}#product_loop_table table tr:last-child {border-left: none !important;border-right: none !important;}#product_loop_table table tr:last-child {border-top: 1px #bababa solid !important;}#product_loop_table table tr:last-child #product_loop_table_total {border: 1px #bababa solid !important;width: 100px !important;}#product_loop_table table { table-layout: auto !important;}</style>";
      let juice_options = { extraCss: additional_css, preserveImportant: true };

      return juice(exportStr, juice_options);
    },
    attachStepDocument(doc, emAttTemp) {
      if (!this.isDocumentAttached(doc))
        this.attachments.push({
          name: doc.name,
          step_id: doc.step_id,
          url: doc.url,
          origin: "step",
          must_merge: emAttTemp && emAttTemp.must_merge,
          order_index: emAttTemp && emAttTemp.order_index,
        });
    },
    attachUploadedDocument(url) {
      this.attachments.push({ name: url, url: url, origin: "uploaded" });
    },
    removeAttachment(index) {
      this.attachments.splice(index, 1);
    },
    removeAttachmentByUrl(url) {
      for (var i = 0; i < this.attachments.length; i++) {
        if (this.attachments[i].url === url) {
          this.attachments.splice(i, 1);
        }
      }
    },
    isDocumentAttached(doc) {
      return this.attachments.find((e) => e.step_id === doc.step_id);
    },
    setShowAttachement(index) {
      this.showedAttachments = this.showedAttachments === index ? -1 : index;
    },
    displayPreview() {
      this.actionDone = false;
      this.show_preview = true;
    },
  },
};
</script>

<style>
.ckborder {
  border: 1px solid var(--ck-color-base-border) !important;
  border-top: none !important;
}

.noBottomBorder > .ck > .ck.ck-editor__main > .ck-editor__editable {
  border-bottom: none;
}

.fileIconBtn {
  height: 64px !important;
  width: 64px !important;
}

.fileList {
  background-color: #f4f4f4 !important;
}

.uploadList {
  background-color: #f4f4f4 !important;
}

.uploadList .v-list__tile {
  height: min-content !important;
}
</style>
